import { Phone, CalendarClock, Banknote } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHONE_TEL } from "../constants/content";

const STEPS = [
    {
        number: "01",
        icon: Phone,
        title: "Give Us A Call",
        desc: "Speak with a Toronto agent in 30 seconds and get a guaranteed cash quote.",
    },
    {
        number: "02",
        icon: CalendarClock,
        title: "Get Offer + Pick-Up Time",
        desc: "Accept the offer and choose a pickup time that suits you. Free flatbed towing included.",
    },
    {
        number: "03",
        icon: Banknote,
        title: "We Drop Off The Cash",
        desc: "We arrive on time, handle all the paperwork, and hand over your cash on the spot.",
    },
];

export const StepsStrip = () => (
    <section className="relative bg-[#F4F4F2] border-b border-[#E3E3DE]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 grid gap-6 md:grid-cols-3">
            {STEPS.map((step, i) => (
                <Reveal key={step.number} delay={i * 0.12}>
                    <a
                        href={PHONE_TEL}
                        data-testid={`step-strip-card-${i}`}
                        className="group relative block h-full rounded-lg border border-[#E3E3DE] bg-white p-8 transition-all duration-500 hover:border-[#FF3B30] hover:-translate-y-1.5"
                    >
                        <span className="font-mono-ind text-5xl font-bold text-[#262938] transition-colors duration-500 group-hover:text-[#FF3B30]">
                            {step.number}
                        </span>
                        <step.icon
                            className="absolute top-8 right-8 h-7 w-7 text-[#FF3B30]"
                            strokeWidth={1.8}
                        />
                        <h3 className="mt-8 font-display font-bold text-xl text-[#141721] tracking-tight">
                            {step.title}
                        </h3>
                        <p className="mt-3 text-sm text-[#565B6B] leading-relaxed">{step.desc}</p>
                    </a>
                </Reveal>
            ))}
        </div>
    </section>
);
